import styled from 'styled-components'

export const Container = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;

  cursor: pointer;

  width: fit-content;

  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input[type='checkbox'] {
    cursor: pointer;

    position: absolute;
    opacity: 0;
  }

  .indicator {
    cursor: pointer;

    border-radius: 3px;
    border: 2px solid ${({ theme }) => `rgb(${theme.grayscale[400]})`};

    display: block;
    width: 1rem;
    height: 1rem;
    background-color: ${({ theme }) => `rgb(${theme.grayscale[400]})`};
    border: 2px solid ${({ theme }) => `rgb(${theme.grayscale[400]})`};
    pointer-events: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    flex-shrink: 0;

    &[data-checked='true'] {
      color: white;
      background: #3b82f6
        url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnIHdpZHRoPSIxMiIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgMTIgOSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgPHBhdGggZD0iTTQuNTc1IDguOTc3cy0uNDA0LS4wMDctLjUzNi0uMTY1TC4wNTcgNS42NGwuODI5LTEuMjI3TDQuNDcgNy4yNjggMTAuOTIxLjA4NmwuOTIzIDEuMTAzLTYuODYzIDcuNjRjLS4xMzQtLjAwMy0uNDA2LjE0OC0uNDA2LjE0OHoiIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPg0KPC9zdmc+)
        50% 40% no-repeat;
      border: 2px solid #3b82f6;
    }
  }
`
